// Your web app's Firebase configuration for breakin-bread-6rr1a
export const firebaseConfig = {
  "projectId": "breakin-bread-6rr1a",
  "appId": "1:570617525024:web:25e6b316e6be487f855d45",
  "apiKey": "AIzaSyB5rm-fDtDCASgxY26o0_DjwT6TWp7_f6A",
  "authDomain": process.env.NEXT_PUBLIC_AUTH_DOMAIN || "breakin-bread-6rr1a.firebaseapp.com",
  "storageBucket": process.env.NEXT_PUBLIC_STORAGE_BUCKET || "breakin-bread-6rr1a.firebasestorage.app",
  "measurementId": "",
  "messagingSenderId": "570617525024"
};
